var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { Animate } from "../Animate";
import { DeviceDetect } from "sb-resp-lib";
import Debounce from "debounce-decorator";
import { observer } from "mobx-react";
/* tslint:disable:cyclomatic-complexity */
/* shouldScroll method creates cyclomatic complexity of 7 */
/* TODO reduce cyclomatic complexity */
var SportsCarousel = /** @class */ (function (_super) {
    __extends(SportsCarousel, _super);
    function SportsCarousel(props) {
        var _this = _super.call(this, props) || this;
        _this.calcs = {
            step: 0,
            container: 0,
            wrapper: 0
        };
        _this.anims = { left: 0 };
        _this.state = {
            scrollable: {
                left: false,
                right: false
            },
            anims: { animation: { translateX: 0 }, duration: 600, easing: [10, 5] },
            deviceType: DeviceDetect.getInstance()
        };
        _this.rtl = document.dir === "rtl" ? true : false;
        _this.carouselDataUat = _this.props.dataUats ? _this.props.dataUats.carousel : "scarousel";
        _this.arrowLeftDataUat = _this.props.dataUats ? _this.props.dataUats.arrowLeft : "scarousel-btn-prev";
        _this.arrowRightDataUat = _this.props.dataUats ? _this.props.dataUats.arrowRight : "scarousel-btn-next";
        return _this;
    }
    /* istanbul ignore next */
    SportsCarousel.prototype.scrollLeft = function () {
        if (this.state.scrollable.left) {
            var l = this.anims.left + this.calcs.step;
            this.anims.left = l > 0 ? 0 : l;
            var o = __assign({}, this.state.anims, { animation: { translateX: (this.rtl ? -1 : 1) * this.anims.left } });
            this.setState({ anims: __assign({}, o) });
        }
    };
    /* istanbul ignore next */
    SportsCarousel.prototype.scrollRight = function () {
        if (this.state.scrollable.right) {
            var t = this.anims.left - this.calcs.step;
            var d = this.calcs.container - this.calcs.wrapper;
            this.anims.left = Math.abs(t) > d ? d * -1 : t;
            var o = __assign({}, this.state.anims, { animation: { translateX: (this.rtl ? -1 : 1) * this.anims.left } });
            this.setState({ anims: __assign({}, o) });
        }
    };
    SportsCarousel.prototype.setupCalcs = function () {
        if (this.wrapper && this.container) {
            this.calcs.step = (this.props.step && this.props.step < this.wrapper.offsetWidth) ? this.props.step : this.wrapper.offsetWidth;
            this.calcs.wrapper = this.wrapper.offsetWidth;
            this.calcs.container = this.container.offsetWidth;
        }
    };
    SportsCarousel.prototype.shouldScroll = function () {
        if (this.wrapper && this.container) {
            var sLeft = this.anims.left < 0 ? true : false;
            var sRight = this.calcs.container - this.calcs.wrapper + this.anims.left > 0 ? true : false;
            if (this.state.scrollable.left !== sLeft ||
                this.state.scrollable.right !== sRight) {
                this.setState({
                    scrollable: {
                        left: sLeft,
                        right: sRight
                    }
                });
            }
        }
    };
    /* istanbul ignore next */
    SportsCarousel.prototype.scrollWheel = function (e) {
        if (e.deltaY < 0) {
            this.scrollLeft();
        }
        else {
            this.scrollRight();
        }
    };
    /* istanbul ignore next */
    SportsCarousel.prototype.resetScroll = function () {
        this.anims.left = 0;
        this.setState({ anims: __assign({}, this.state.anims, { animation: { translateX: 0 } }) });
    };
    /* istanbul ignore next */
    SportsCarousel.prototype.handleEvent = function (e) {
        if (e.type === "resize") {
            this.resetScroll();
            if (this.state.deviceType.isDesktop) {
                this.setupCalcs();
                this.shouldScroll();
            }
        }
    };
    /* istanbul ignore next */
    SportsCarousel.prototype.onClickArrowsHandler = function (direction) {
        this["scroll" + direction]();
        this.shouldScroll();
    };
    SportsCarousel.prototype.updateScrollPosition = function () {
        this.shouldScroll();
        var o = __assign({}, this.state.anims, { animation: { translateX: this.anims.left } });
        this.setState({ anims: __assign({}, o) });
    };
    SportsCarousel.prototype.componentDidMount = function () {
        if (this.state.deviceType.isDesktop) {
            this.setupCalcs();
            this.shouldScroll();
            window.addEventListener("resize", this);
            this.container && this.container.addEventListener("wheel", this.scrollWheel.bind(this));
        }
        else {
            this.resetScroll();
        }
    };
    SportsCarousel.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.setupCalcs();
        this.shouldScroll();
    };
    SportsCarousel.prototype.render = function () {
        var _this = this;
        var cls = "rj-sports-carousel";
        cls += this.state.scrollable.left ? " rj-sports-carousel--sLeft" : "";
        cls += this.state.scrollable.right ? " rj-sports-carousel--sRight" : "";
        return (React.createElement("div", { className: cls, "data-uat": this.carouselDataUat, ref: function (n) { return _this.wrapper = n; } },
            (this.state.deviceType.isDesktop) &&
                (React.createElement("div", { className: "rj-sports-carousel-arrow rj-sports-carousel-arrow-left", "data-uat": this.arrowLeftDataUat, onClick: this.onClickArrowsHandler.bind(this, "Left") },
                    React.createElement("div", { className: "rj-sports-carousel-arrow--inner" }))),
            (this.state.deviceType.isDesktop) &&
                (React.createElement("div", { className: "rj-sports-carousel-arrow rj-sports-carousel-arrow-right", "data-uat": this.arrowRightDataUat, onClick: this.onClickArrowsHandler.bind(this, "Right") },
                    React.createElement("div", { className: "rj-sports-carousel-arrow--inner" }))),
            React.createElement(Animate, __assign({}, this.state.anims),
                React.createElement("div", { className: "rj-sports-carousel-container", ref: function (n) { return _this.container = n; } }, this.props.children))));
    };
    __decorate([
        Debounce(50),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SportsCarousel.prototype, "scrollWheel", null);
    __decorate([
        Debounce(50),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SportsCarousel.prototype, "resetScroll", null);
    __decorate([
        Debounce(50),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Event]),
        __metadata("design:returntype", void 0)
    ], SportsCarousel.prototype, "handleEvent", null);
    __decorate([
        Debounce(50),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], SportsCarousel.prototype, "onClickArrowsHandler", null);
    SportsCarousel = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], SportsCarousel);
    return SportsCarousel;
}(React.Component));
export { SportsCarousel };
//# sourceMappingURL=SportsCarousel.js.map